import React, { useState, useEffect } from 'react';

export default function PageHeader({ title, subtitle, isArabic }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div
      dir={isArabic ? 'rtl' : 'ltr'}
      style={{
        marginTop: isMobile ? 16 : 0,
        marginBottom: isMobile ? 24 : 32,
        paddingLeft: 0,
        paddingRight: 0,
        fontFamily: "'IBM Plex Sans Arabic', Arial, sans-serif",
      }}
    >
      <h1
        style={{
          fontSize: isMobile ? 28 : 28,
          fontWeight: 700,
          margin: 0,
          marginBottom: 8,
          textAlign: isArabic ? 'right' : 'left',
          color: '#1E293B',
          letterSpacing: '-0.5px',
          lineHeight: '1.2',
        }}
      >
        {title}
      </h1>
      <p
        style={{
          color: '#64748B',
          margin: 0,
          fontSize: 14,
          textAlign: isArabic ? 'right' : 'left',
          fontWeight: 400,
          lineHeight: '1.6',
          maxWidth: '100%',
        }}
      >
        {subtitle}
      </p>
    </div>
  );
}

